import React, {useEffect, useState} from 'react';
import {Checkbox, Form, Input, Modal, Select, Switch} from "antd";
const { Option } = Select;
const { TextArea } = Input;

const formItemLayout = {
    wrapperCol: {offset: 5, span: 19},
};

const tailItemLayout = {
    labelCol: {span: 5},
    wrapperCol: {span: 19},
};


const AdminStrategyDialog = ({  visible = false, data = {},
                        dialogHandler = () => {}
                     }) => {
    const {code, name, description} = data;
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            code, name, description
        })
    }, [description, form, name, code]);

    useEffect(() => {
        if (visible) {
            // Сбрасываем форму и устанавливаем новые значения
            form.resetFields();
            form.setFieldsValue({
                code: code || '',
                name: name || '',
                description: description || ''
            });
        }
    }, [visible, code, name, description, form]);


    const onOk = () => {
        form.validateFields().then(values => {
            values = {
                ...data,
                ...values
            }
            dialogHandler(true, {...values})
        });
    }

    return (
        <Modal
            title= {code ? 'Редактирование стратегии': 'Новая стратегия'}
            className="uk-panel-title"
            open={visible}
            onCancel={() => dialogHandler(false)}
            onOk={onOk}
            width={600}
        >
            <Form form={form}>
                <Form.Item label="Код"  {...tailItemLayout}
                          name='code'
                          rules={[{required: true, message: 'Пожалуйста, введите код стратегии.'}]}>
                    <Input placeholder="Введите код стратегии" />
                </Form.Item>

                <Form.Item label="Наименование"  {...tailItemLayout}
                          name='name'
                          rules={[{required: true, message: 'Пожалуйста, введите наименование.'}]}>
                    <Input placeholder="Введите наименование" />
                </Form.Item>

                <Form.Item label="Описание"  {...tailItemLayout}
                          name='description'
                          rules={[{required: false}]}>
                    <TextArea placeholder="Комментарий" autosize={{minRows: 2}}/>
                </Form.Item>

            </Form>
        </Modal>
    );

}

export default AdminStrategyDialog;
